import React, { FC } from "react";
import { Unit as UnitType } from "../types";

const QuantityWithUnit: FC<{ quantity: number; unit: UnitType }> = ({
  quantity,
  unit,
}) => <>{` ${quantity <= 1 ? unit[0] : unit[1]}`}</>;

export default QuantityWithUnit;
